import {
  testKitsPrimary,
  testKitsSecondary,
  multiplexTestKits,
  rsvTestKits
} from "../testKits";

export const getAvailableTestTypes = (tests, themeTestTypes = []) => {
  if (themeTestTypes.length) {
    // Include both the primary and secondary test kits if the themeTestTypes is available,
    // because it may only be in the secondary test kits
    const testsAvailable =
      tests.length > 1
        ? multiplexTestKits
        : [...testKitsPrimary, ...testKitsSecondary];
    return themeTestTypes
      ? testsAvailable.filter((test) => themeTestTypes.includes(test))
      : testsAvailable;
  }
  const targets = Array.isArray(tests) ? tests.map(t => t.testTarget) : [];
  const hasRSV = targets.includes("rsv");
  if (hasRSV) {
    return rsvTestKits;
  }
  return tests.length > 1 ? multiplexTestKits : testKitsPrimary;

};
